/** Small JSON fetch helper for the non-sync endpoints. Throws with the server's message on failure. */
export async function api<T = unknown>(path: string, init: { method?: string; json?: unknown; body?: BodyInit } = {}): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? (init.json !== undefined || init.body ? "POST" : "GET"),
    credentials: "include",
    headers: init.json !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: init.json !== undefined ? JSON.stringify(init.json) : init.body,
  });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try { const j = await res.json(); message = j.message ?? j.error ?? message; } catch { /* not json */ }
    throw new Error(message);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
